import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerOverlayComponent } from '../spinner-overlay/spinner-overlay';

@Component({
  selector: 'app-chart-host-overlay',
  imports: [CommonModule, SpinnerOverlayComponent],
  templateUrl: './chart-host-overlay.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './chart-host-overlay.css',
})
export class ChartHostOverlayComponent implements AfterViewInit {
  @ViewChild('chartHost', { static: true }) private chartHostRef?: ElementRef<HTMLDivElement>;

  @Input() loading = false;
  @Input() loadingLabel = 'Chargement...';
  @Input() ariaLabel = 'Graphique';

  @Output() hostReady = new EventEmitter<HTMLDivElement>();

  ngAfterViewInit() {
    const host = this.chartHostRef?.nativeElement;
    if (host) {
      this.hostReady.emit(host);
    }
  }
}
